import { Difficulty } from '../hooks/gameReducer'
import { createId } from './localStorage'

export const HASH_PARAM_KEY_ID = 'i'
export const HASH_PARAM_KEY_DIFFICULTY = 'd'
export const HASH_PARAM_KEY_SOLUTION = 's'
export const HASH_PARAM_KEY_CREATOR = 'c'

export const getHashParams = (): { [key: string]: string | undefined } => {
  if (typeof window === 'undefined') return {}
  const hash = window.location.hash.substring(1)
  const hashComponents = hash.split('&')
  const hashParamsComponents = hashComponents.map((hashComponent) =>
    hashComponent.split('=')
  )
  const hashParams: { [key: string]: string | undefined } = {}
  hashParamsComponents.forEach((hashParamComponents) => {
    if (hashParamComponents.length !== 2) {
      return
    }
    hashParams[hashParamComponents[0]] = hashParamComponents[1]
  })
  return hashParams
}

const createHashString = (params: { key: string; value: string }[]) => {
  let firstParam = true
  let hashString = '#'
  for (const param of params) {
    const { key, value } = param
    hashString = `${hashString}${firstParam ? '' : '&'}${key}=${value}`
    firstParam = false
  }
  return hashString
}

const encodeHashParam = (value: string) => {
  return encodeURIComponent(btoa(unescape(encodeURIComponent(value))))
}

const decodeHashParam = (value: string) => {
  return decodeURIComponent(escape(atob(decodeURIComponent(value))))
}

export const getDecodedHashParam = (key: string) => {
  const hashParams = getHashParams()
  const valueEncoded = hashParams[key]
  return valueEncoded === undefined ? undefined : decodeHashParam(valueEncoded)
}

export const createCustomGameUrl = (
  solution: string,
  creator: string,
  difficulty: Difficulty
) => {
  const solutionValue = encodeHashParam(solution)
  const creatorValue = encodeHashParam(creator)
  const urlBeginning =
    typeof window !== 'undefined' ? window.location.href.split('#')[0] : '/'
  const hashString = createHashString([
    { key: HASH_PARAM_KEY_SOLUTION, value: solutionValue },
    { key: HASH_PARAM_KEY_CREATOR, value: creatorValue },
    { key: HASH_PARAM_KEY_DIFFICULTY, value: difficulty.toString() },
  ])
  const fullUrl = `${urlBeginning}${
    urlBeginning.endsWith('/') ? '' : '/'
  }${hashString}`
  return fullUrl
}

export const createCustomStatURl = () => {
  const id = createId()
  const idValue = encodeHashParam(id)
  const urlBeginning =
    typeof window !== 'undefined' ? window.location.origin.split('#')[0] : '/'
  const hashString = createHashString([
    { key: HASH_PARAM_KEY_ID, value: idValue },
  ])
  const fullUrl = `${urlBeginning}${
    urlBeginning.endsWith('/') ? '' : '/'
  }${hashString}`
  return fullUrl
}
